<template>
  <section class="moresetting-wrap">
    <div class="moresetting-header" @click="toggleFlag = !toggleFlag">
      <div class="moresetting-hcontent">
        <span>{{ toggleFlag ? '收起' : '展开' }}{{ title }}</span>
        <el-icon :size="16" color="#515358" v-if="!toggleFlag"><ArrowDown /></el-icon>
        <el-icon :size="16" color="#515358" v-if="toggleFlag"><ArrowUp /></el-icon>
      </div>
    </div>
    <div class="moresetting-body-wrap" :class="{ show: toggleFlag }">
      <div class="moresetting-body">
        <slot></slot>
      </div>
      <div ref="slotTarget" />
    </div>
  </section>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import { Close, Search, Minus, ArrowDown, ArrowUp, CirclePlus, RemoveFilled, CirclePlusFilled } from '@element-plus/icons-vue'

  defineProps({
    title: {
      type: String,
      default: '更多设置'
    }
  })

  const emit = defineEmits(['change'])

  const toggleFlag = ref(false);

  const slotTarget = ref(null)
  watch(() => toggleFlag.value, () => {
    if(toggleFlag.value) {
      setTimeout(() => {
        slotTarget.value.scrollIntoView({ behavior: 'smooth', block: 'end', inline: "nearest" });  
      }, 100)
    }

    emit('change', toggleFlag.value)
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>